import api from "../../Api/feathers-client";

// Call backend service to create users
export const createUsers = async (data) => {
  return new Promise(async (resolve, reject) => {
    try {
      let response = await api.service("users").create(data, {});
      resolve({
        status: 201,
        message: "Users Created",
        data: response,
      });
    } catch (error) {
      console.log("error===>", error);
      resolve(error);
    }
  });
};

// Call backend service to update users
export const updateUsers = async (data, uid) => {
  return new Promise(async (resolve, reject) => {
    try {      
      let response = await api.service("users").patch(null, data, {
        query: {
          uid,
        },
      });

      resolve({
        status: 201,
        message: "Users Updated",
        data: response,
      });
    } catch (error) {
      resolve(error);
    }
  });
};

export const getUsersDb = async (params) => {
  return new Promise(async (resolve, reject) => {
    try {
      let response = await api.service("users").find(params);
      resolve({
        status: 201,
        message: "Users List",
        data: response,
      });
    } catch (error) {
      console.log("error==>", error);
      resolve(error);
    }
  });
};

export const getLocalityList = async (passParams) => {
  return new Promise(async (resolve, reject) => {
    try {
      let localityRes = await api.service("locality").find(passParams);
      resolve({
        status: 201,
        message: "Locality List",
        data: localityRes.data,
      });
    } catch (error) {
      console.log("error==>", error);
      reject(error);
    }
  });
};

export const getStudentsDb = async (params) => {
  return new Promise(async (resolve, reject) => {
    try {
      let response = await api.service("students").find(params);
      resolve({
        status: 201,
        message: "Students List",
        data: response,
      });
    } catch (error) {
      console.log("error==>", error);
      resolve(error);
    }
  });
};

export const updateStudents = async (id, data, params) => {
  // allowedweblogin true/false, set user delete
  return new Promise(async (resolve, reject) => {
    try {
      let response = await api.service("students").patch(id, data, params);
      console.log("response", response);
      resolve({
        status: 201,
        message: "All Students Updated",
        data: response.data ? response.data : response[0],
      });
    } catch (error) {
      resolve(error);
    }
  });
};

export const updateStudentAttendance = async (data, query) => {
  return new Promise(async (resolve, reject) => {
    try {
      let response = await api
        .service("student-attendances")
        .patch(null, data, {
          query: query,
        });
      resolve({
        status: 200,
        message: "Students Attendance Inserted",
        data: response,
      });
    } catch (error) {
      console.log("error==>", error);
      resolve(error);
    }
  });
};

export const getUserRequestsDb = async (params) => {
    return new Promise(async (resolve, reject) => {
        try {
            let response = await api.service("user-requests").find(params);
            resolve({
                status: 201,
                message: "User Requests List",
                data: response,
            });
        } catch (error) {
            console.log("error==>", error);
            resolve(error);
        }
    });
};

export const getPermissionsDb = async (params) => {
    return new Promise(async (resolve, reject) => {
        try {
            let response = await api.service("permissions").find(params);
            resolve({
                status: 201,
                message: "Permissions List",
                data: response,
            });
        } catch (error) {
            console.log("error==>", error);
            resolve(error);
        }
    });
};

export const getAddressFromLatLong = async (params) => {
    return new Promise(async (resolve, reject) => {
        try {
            let response = await api.service("get-address-from-latlong").find(params);
            resolve({
                status: 201,
                message: "User Address from LatLong",
                data: response,
            });
        } catch (error) {
            console.log("error==>", error);
            resolve(error);
        }
    });
};

export const updateUserLogs = async (data, uid) => {
  return new Promise(async (resolve, reject) => {
    try {
      let response = await api.service("user-logs").patch(null, data, {
        query: {
          uid,
        },
      });
      resolve({
        status: 201,
        message: "User Logs Updated",
        data: response,
      });
    } catch (error) {
      resolve(error);
    }
  });
};
